// extracted by mini-css-extract-plugin
export default {"selectColumns":"styles_selectColumns__qo0Ca"};